import { AxiosRequestConfigMethods } from "@/api/types";
import { fetchFromBrandedUrl } from "@/api/utils";

import { brandUrl } from "@/api/utils";
import {
  AddAmbassadorResponse,
  GetAmbassadorsParams,
  GetAmbassadorsResponse,
} from "@/modules/ambassadors/types";
import { EnvironmentVariables } from "@/modules/common/types";

export const getAmbassadors = async (
  params: GetAmbassadorsParams
): Promise<GetAmbassadorsResponse> => {
  const apiUrl = brandUrl<GetAmbassadorsResponse>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/ambassadors`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params,
    },
  });
};

export const getPartnersLeadsCount = async (
  partnerUIds: string[]
): Promise<{ partnerUId: string; count: number }[]> => {
  const apiUrl = brandUrl<{ partnerUId: string; count: number }[]>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/brokers/get-partners-leads-count`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params: {
        partnerUIds: partnerUIds.join(","),
      },
    },
  });
};

export const addAmbassador = async (body: {
  phone: string;
  invitationTypeId: number;
  salesAgentDefaultEmail: string;
  officialName?: string;
}): Promise<AddAmbassadorResponse> => {
  const apiUrl = brandUrl<AddAmbassadorResponse>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/ambassadors`
  );
  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
      data: {
        ...body,
      },
    },
  });
};
